import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "centered-div" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[11] || (_cache[11] = _createElementVNode("h2", null, "Login", -1)),
    _createElementVNode("form", {
      onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleLogin && _ctx.handleLogin(...args)), ["prevent"]))
    }, [
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.mail) = $event)),
        type: "mail",
        placeholder: "Email",
        required: ""
      }, null, 512), [
        [_vModelText, _ctx.mail]
      ]),
      _cache[3] || (_cache[3] = _createElementVNode("br", null, null, -1)),
      _cache[4] || (_cache[4] = _createElementVNode("br", null, null, -1)),
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event)),
        type: "password",
        placeholder: "Password",
        required: ""
      }, null, 512), [
        [_vModelText, _ctx.password]
      ]),
      _cache[5] || (_cache[5] = _createElementVNode("br", null, null, -1)),
      _cache[6] || (_cache[6] = _createElementVNode("br", null, null, -1)),
      _cache[7] || (_cache[7] = _createElementVNode("button", { type: "submit" }, "Login", -1)),
      _cache[8] || (_cache[8] = _createElementVNode("br", null, null, -1)),
      _cache[9] || (_cache[9] = _createElementVNode("br", null, null, -1)),
      _cache[10] || (_cache[10] = _createElementVNode("br", null, null, -1))
    ], 32)
  ]))
}